// extracted by mini-css-extract-plugin
export default {"header":"styles_header__JL6SE","wave":"styles_wave__tZxKS","content":"styles_content__S+N+U"};